import { FC, useCallback, useMemo } from "react";
import { Dialog, DialogContent, Box, Button } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { HelpOutline } from "@mui/icons-material";
import { Projeto, ProjetosComponentesModificados } from "../types";
import { SITUACAO_COMPONENTE } from "./type";
import theme from "src/theme/light";

interface TrocaPendenteProps {
    open: boolean;
    onClose: (event: any, reason: string) => void;
    onConfirm: () => void;
    onCancel: (componentesSubstituidosIds: number[], componentesNovosIds: number[], componentesRemovidosIds: number[]) => void;
    data: Projeto | null;
}

const useStyles = makeStyles({
  paper: {
    minWidth: "450px",
  }
})

const TrocaPendente: FC<TrocaPendenteProps> = ({
    open,
    onClose,
    onCancel,
    onConfirm,
    data
}) => {

  const classes = useStyles()

  const items = useMemo(() => {
    const componentesIds = data?.componentes?.map(item => item.componente_id) || []
    const substituidosRemovidos: ProjetosComponentesModificados[] = []
    const substituidosAdicionados: ProjetosComponentesModificados[] = []
    const novos: ProjetosComponentesModificados[] = []
    const removidos: ProjetosComponentesModificados[] = []

    if (data?.componentes_modificados?.length) {
      substituidosAdicionados.push(...data.componentes_modificados.filter(item => item.situacao === SITUACAO_COMPONENTE.NOVO && !!item.componente_substituido_id && !componentesIds.includes(item.componente_id)))
      substituidosAdicionados.forEach(item => {
        const comp = data.componentes_modificados?.find(modificado => modificado.componente_id === item.componente_substituido_id)
        if (comp) {
          substituidosRemovidos.push(comp)
        }
      })
      novos.push(...data.componentes_modificados.filter(item => item.situacao === SITUACAO_COMPONENTE.NOVO && !item.componente_substituido_id && !componentesIds.includes(item.componente_id)))
      removidos.push(...data.componentes_modificados.filter(item => item.situacao === SITUACAO_COMPONENTE.EXCLUIDO && !item.componente_substituido_id && componentesIds.includes(item.componente_id)))
    }

    return {
      substituidosRemovidos,
      substituidosAdicionados,
      novos,
      removidos
    }
  }, [data])

  const onCancelChange = useCallback(()=> {
    onCancel(
      items.substituidosAdicionados.map(item => item.componente_id),
      items.novos.map(item => item.componente_id),
      items.removidos.map(item => item.componente_id),
      )
  },[onCancel, items])

  return (
      <Dialog disableEscapeKeyDown onClose={onClose} open={open} maxWidth={"xs"} classes={{ paper: classes.paper  }}> 
        <DialogContent style={{ padding: "30px" }}>
          <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
            <HelpOutline color="disabled" style={{ fontSize: "100px" }} />

            <h2>Troca Pendente</h2>
            <Box component={"span"} width={"80%"} textAlign={"center"}>Este projeto possui uma troca não efetivada.<br></br></Box>
            <Box component={"span"} width={"80%"} textAlign={"center"}>Veja informações abaixo:</Box>
          </Box>

        {!!items.substituidosRemovidos.length && (
          <>
            <strong>De:</strong>
            {items.substituidosRemovidos.map(itemSubtituido => (
              <Box key={itemSubtituido.componente_id} component={"ul"} style={{ paddingLeft: "15px" }}>
                <li>{itemSubtituido.quantidade}x {itemSubtituido.modelo} ({itemSubtituido.componente_id})</li>
              </Box>
            ))}
          </>
        )}

        {!!items.substituidosAdicionados.length && (
          <>
            <strong>Para:</strong>
            {items.substituidosAdicionados.map(itemSubtituido => (
              <Box key={itemSubtituido.componente_id} component={"ul"} style={{ paddingLeft: "15px" }}>
                <li>{itemSubtituido.quantidade}x {itemSubtituido.modelo} ({itemSubtituido.componente_id})</li>
              </Box>
            ))}
          </>
        )}


        {!!items.novos.length && (
          <>
            <strong>Adicionado:</strong>
            {items.novos.map(itemSubtituido => (
              <Box key={itemSubtituido.componente_id} component={"ul"} style={{ paddingLeft: "15px" }}>
                <li>{itemSubtituido.quantidade}x {itemSubtituido.modelo} ({itemSubtituido.componente_id})</li>
              </Box>
            ))}
          </>
        )}

        {!!items.removidos.length && (
          <>
            <strong>Removido:</strong>
            {items.removidos.map(itemSubtituido => (
              <Box key={itemSubtituido.componente_id} component={"ul"} style={{ paddingLeft: "15px" }}>
                <li>{itemSubtituido.quantidade}x {itemSubtituido.modelo} ({itemSubtituido.componente_id})</li>
              </Box>
            ))}
          </>
        )}

        <Box display={"flex"} justifyContent={"center"} marginTop="40px">
          <Button variant="contained" color="primary" onClick={onConfirm}>Aplicar Troca</Button>
          <Button variant="contained" onClick={onCancelChange} style={{ backgroundColor: theme.palette.error.main, color: "white", marginLeft: "10px" }}>Excluir Troca</Button>
        </Box>

        </DialogContent>
      </Dialog>
    )
}

export { TrocaPendente } 